import { parsePolicyText } from '@repo/common';

const TEXT = `# 제1장 총칙
## 제1조(목적)
이 약관은 오잉랩(브랜드명 "코레디", 이하 "회사")이 운영하는 O!ng Lab 서비스(웹사이트 www.ko-ready.com 및 이에 부수하는 일체의 서비스, 이하 '서비스')의 이용조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

## 제2조(용어의 정의)
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
· '서비스'란 회사가 글로벌 이용자를 위하여 제공하는 한국어 학습, 한국 문화 체험, 커리어 개발, 한국 정착 지원 및 이에 부수하는 일체의 온·오프라인 서비스를 말합니다.
· '이용자'란 이 약관에 동의하고 서비스를 이용하는 회원 및 비회원을 말합니다.
· '회원'이란 회사에 개인정보를 제공하고 회원가입을 완료하여 서비스를 이용하는 자를 말합니다.
· '콘텐츠'란 회사가 제공하는 오프라인 워크숍, 온라인 라이브 세션, 비디오 코스, 다운로드 자료, 뷰온리 자료, 번들 및 기타 유·무료 상품을 말합니다.
· '디지털콘텐츠'란 「콘텐츠산업 진흥법」 및 「전자상거래 등에서의 소비자보호에 관한 법률」상 정보통신망을 통하여 제공되는 비디오 코스, 다운로드 자료, 뷰온리 자료 등을 말합니다.
· '가분적 디지털콘텐츠'란 다수의 강의·차시 등으로 구성되어 그 제공을 부분으로 나눌 수 있는 디지털콘텐츠를 말합니다.
· '번들'이란 둘 이상의 콘텐츠를 묶어 판매하는 상품을 말합니다.

## 제3조(약관의 효력 및 변경)
① 이 약관은 이용자가 약관에 동의하고 서비스를 이용하는 시점부터 효력이 발생합니다.

② 회사는 「약관의 규제에 관한 법률」, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보 보호법」 등 관련 법령에 위배되지 않는 범위에서 이 약관을 변경할 수 있습니다.

③ 회사가 약관을 변경하는 경우, 변경 내용이 이용자에게 불리한 경우에는 적용일 30일 전부터, 그 외의 경우에는 적용일 7일 전부터 서비스 공지사항, 이메일 또는 사이트 공지 등의 방법으로 그 사유와 내용을 공지합니다.

④ 이용자가 변경 약관 시행일 이후에도 서비스를 계속 이용하는 경우 변경 약관에 동의한 것으로 봅니다. 동의하지 않는 이용자는 이용계약을 해지할 수 있습니다.

## 제4조(약관의 해석 및 언어)
① 이 약관에서 정하지 않은 사항은 「약관의 규제에 관한 법률」, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「콘텐츠산업 진흥법」, 「개인정보 보호법」 등 관련 법령 및 상관례에 따릅니다.

② 회사는 이 약관을 국문 외 영문 등으로 제공할 수 있습니다. 각 언어본의 내용이 상충하는 경우 국문본을 우선하여 해석합니다. 다만 이용자의 상거소지 법령이 소비자 보호를 위하여 달리 정하는 경우에는 그러하지 아니합니다.

# 제2장 이용계약 및 계정
## 제5조(이용계약의 성립)
① 이용계약은 이용자가 이 약관에 동의하고 회원가입을 완료하거나 서비스를 이용한 때에 성립합니다.

② 회사는 다음 각 호에 해당하는 경우 이용신청을 거절하거나 사후에 이용계약을 해지할 수 있습니다.
· 등록 내용에 허위, 기재 누락, 오기가 있는 경우
· 과거 이 약관 위반 또는 부정 이용으로 이용이 제한된 경우
· 기타 회사가 정한 이용신청 요건을 충족하지 않는 경우

## 제6조(이용 자격 및 연령 확인)
① 서비스는 만 18세 이상인 자가 이용할 수 있습니다.

② 회사는 회원가입 시 생년월일 확인을 통하여 만 18세 미만의 가입을 제한하며, 이를 위한 기술적 조치를 마련합니다.

③ 회사는 「개인정보 보호법」 제22조의2에 따라 만 14세 미만 아동의 개인정보를 원칙적으로 수집하지 않으며, 만 14세 미만 아동이 가입한 사실을 알게 된 경우 지체 없이 해당 정보를 파기합니다.

## 제7조(회원정보 및 계정관리)
① 회원은 서비스에 등록한 정보를 정확하게 입력하고 최신 상태로 유지하여야 합니다.

② 회원은 계정 및 비밀번호를 안전하게 관리하여야 하며, 이를 타인에게 양도·대여·공유할 수 없습니다.

③ 회원은 계정이 무단으로 이용된 것을 알게 된 경우 즉시 회사(contact@ko-ready.com)에 통지하여야 하며, 회사는 이용자 또는 다른 이용자의 보호를 위하여 계정 이용을 일시 제한할 수 있습니다.

# 제3장 서비스의 제공 및 이용
## 제8조(서비스의 내용)
회사가 제공하는 서비스는 다음과 같으며, 각 상품의 일정·이용기간·가격·환불 조건 등 세부사항은 상품 페이지에 게시합니다.
· 오프라인 워크숍 — 한국에서 진행되는 날짜 고정형 오프라인 행사
· 온라인 라이브 세션 — 날짜 및 시간이 고정된 실시간 온라인 세션
· 비디오 코스 — 서비스 내에서 시청하는 녹화 강의
· 다운로드 자료 — 이용자의 기기에 저장할 수 있는 파일(예: PDF)
· 뷰온리 자료 — 서비스 내에서만 열람 가능한 자료(다운로드 불가)
· 번들 — 위 상품 중 둘 이상을 묶은 패키지
· 커리어 및 정착 지원 도구(Pathfinder 등)

## 제8조의2(채용정보 서비스)
회사는 제8조의 서비스와 함께 다음의 채용정보 관련 서비스를 제공합니다.
· 기업회원이 등록한 채용공고의 검색 및 열람
· 이력서의 등록 및 관리
· 채용공고에 대한 지원
· 이용자에게 적합한 채용공고의 추천
· 그 밖에 구인·구직과 관련하여 회사가 제공하는 제반 서비스

## 제8조의3(회사의 지위 및 보증의 부인)
① 회사는 이용자와 기업회원 사이의 정보 제공과 교류를 위한 플랫폼을 제공하며, 그 운영과 관리에 관한 책임을 부담합니다.

② 회사는 이용자 또는 기업회원을 대리하지 아니하며, 이용자와 기업회원 사이에 성립된 채용 관련 합의나 계약의 당사자가 아닙니다.

③ 회사는 기업회원이 등록한 채용공고 및 기업정보, 이용자가 등록한 이력서 등 회원이 제공한 정보의 진실성·정확성·적법성을 보증하지 아니하며, 각 정보에 대한 책임은 이를 등록한 회원이 부담합니다.

④ 회사는 이용자의 지원 결과나 채용 여부를 보장하지 아니합니다.

## 제9조(서비스 이용시간 및 시간대 안내)
① 서비스는 연중무휴 제공함을 원칙으로 하되, 회사의 사정 또는 제19조의 사유로 제한될 수 있습니다.

② 오프라인 워크숍 및 온라인 라이브 세션의 일시는 한국표준시(KST, UTC+9)를 기준으로 표시됩니다. 이용자는 예약 전 자신의 현지 시간을 확인하여야 합니다.

## 제10조(이용자의 의무 및 금지행위)
① 이용자는 정확한 정보를 제공하고, 서비스를 개인적·합법적 목적으로만 이용하여야 하며, 다른 학습자·크리에이터·임직원을 존중하여야 합니다.

② 이용자는 다음 각 호의 행위를 하여서는 안 됩니다.
· 유료 콘텐츠를 타인이 이용하도록 계정을 공유하는 행위
· 유료 콘텐츠를 무단으로 복사·녹화·다운로드(허용된 경우 제외)·재판매·외부 공유하는 행위
· 허가 없이 워크숍 또는 라이브 세션을 녹화하는 행위
· 다른 이용자 또는 임직원을 괴롭히거나 위협하는 등 해로운 행위
· 자동화 도구로 서비스에 무단 접근하거나 서비스를 방해·손상하는 행위
· 허위 정보를 제공하거나 타인을 사칭하는 행위, 기타 관련 법령 또는 이 약관을 위반하는 행위

## 제11조(콘텐츠의 지식재산권 및 이용허락)
① 서비스 및 콘텐츠에 관한 저작권 등 지식재산권은 회사 또는 정당한 권리자에게 귀속됩니다.

② 이용자는 상품 구매를 통하여 개인적·비양도적 이용 허락을 부여받으며, 콘텐츠를 재이용·재판매·재배포하거나 서비스 외부에서 복제·공유할 수 없습니다.

## 제12조(이용자 생성 콘텐츠)
① 이용자가 서비스 내에 질문·리뷰 등 콘텐츠를 게시하는 경우 그 저작권은 이용자에게 귀속됩니다.

② 이용자는 회사가 서비스 운영·개선을 위하여 해당 콘텐츠를 서비스 내에서 이용할 수 있도록 허락하며, 회사는 관련 법령이나 이 약관을 위반하는 콘텐츠를 삭제하거나 이용을 제한할 수 있습니다.

## 제12조의2(이력서의 등록 및 제공)
① 이용자는 서비스에 이력서를 등록하고 관리할 수 있습니다.

② 이용자가 등록한 이력서는 이용자가 채용공고에 지원하는 경우에 한하여 해당 채용공고를 등록한 기업회원에게 제공됩니다.

③ 회사는 이용자의 지원 없이 기업회원이 이용자의 이력서를 검색하거나 열람할 수 있는 기능을 제공하지 않습니다.

④ 회사는 이용자의 등록 정보와 서비스 내 활동을 기준으로 이용자에게 적합한 채용공고를 추천할 수 있습니다.

## 제12조의3(채용 지원 및 서류 제출에 대한 동의)
① 이용자는 기업회원이 등록한 채용공고에 지원할 수 있으며, 지원 시 이력서 등 회사가 정한 서류(이하 '제출 서류')를 제출합니다.

② 제출 서류는 채용을 목적으로 해당 채용공고를 등록한 기업회원에게 공유됩니다.

③ 이용자가 지원 요청을 전송하면 이 약관 및 개인정보처리방침에 동의하고, 채용을 위한 서류의 제출·공유에 동의한 것으로 봅니다. 동의하지 않는 경우 지원을 진행할 수 없습니다.

④ 회사는 제2항 및 제3항의 내용을 지원 화면 등 이용자가 쉽게 알 수 있는 곳에 명확히 표시하고, 이용자가 이를 확인하는 절차(체크박스 등)를 갖춥니다.

⑤ 이용자는 제출 서류를 사실에 근거하여 정확하게 작성하여야 하며, 허위 또는 부정확한 기재로 발생하는 책임은 이용자가 부담합니다.

⑥ 지원 이후의 채용 절차(서류 심사, 면접, 합격 여부 결정 등)는 해당 기업회원이 자신의 기준과 절차에 따라 진행하며, 회사는 이에 관여하지 아니합니다.

## 제12조의4(제출 서류의 열람 기간 및 열람 권한의 종료)
① 기업회원의 제출 서류 열람 권한은 다음 각 호의 기준에 따라 종료됩니다.
· 최종 합격한 경우: 공식 입사일부터 최대 90일이 되는 날
· 불합격한 경우: 해당 채용 절차가 종료된 즉시

② 회사는 제1항의 기간이 지나면 해당 기업회원의 열람 권한을 종료하며, 기업회원은 열람 권한이 종료된 후 제출 서류를 채용 목적으로 계속 보유할 수 없습니다. 다만 관련 법령에 따라 보관이 필요한 경우에는 해당 법령에서 정한 기간 동안 보관할 수 있습니다.

③ 이용자는 채용 절차가 진행 중인 경우에도 지원을 철회하거나 제12조의3에 따른 동의를 철회할 수 있으며, 이 경우 회사는 해당 기업회원의 열람 권한을 지체 없이 종료합니다. 다만 이미 기업회원에게 전달된 정보의 파기는 해당 기업회원의 개인정보 처리 기준과 관련 법령에 따릅니다.

## 제12조의5(지원자 정보의 취급)
① 이용자의 지원을 통하여 기업회원에게 제공된 이용자의 이력서 및 제출 서류는 해당 기업회원의 인사자료에 해당하며, 그 관리는 해당 기업회원의 개인정보 처리 기준과 관련 법령에 따릅니다.

② 기업회원은 제공받은 정보를 채용 또는 인력 모집 목적으로만 사용하여야 하며, 영업·마케팅 목적으로 활용하거나 제3자에게 제공할 수 없습니다. 회사는 기업회원 이용약관을 통하여 기업회원에게 이러한 의무를 부과합니다.

③ 이용자는 기업회원의 정보 취급에 관한 문의 또는 신고를 회사에 접수할 수 있으며, 회사는 사실을 확인한 후 기업회원 이용약관 및 관련 법령에 따라 이용 제한 등 필요한 조치를 취할 수 있습니다.

④ 회사는 안정적인 서비스 제공을 위한 테스트·모니터링 및 고객문의 응대 등 운영에 필요한 범위에서 이용자의 이력서 정보를 열람할 수 있습니다.

## 제12조의6(지원 관련 이용자의 의무)
① 이용자는 서비스를 구직 및 채용 지원의 목적으로 이용하여야 합니다.

② 이용자는 다음 각 호의 행위를 하여서는 안 됩니다.
· 타인의 이력서 또는 경력·자격 정보를 자신의 것으로 제출하는 행위
· 이력서 또는 제출 서류에 허위 사실을 기재하는 행위
· 자동화 도구를 이용하여 채용공고를 수집하거나 대량으로 지원하는 행위
· 채용공고를 통하여 알게 된 기업회원의 정보를 구직 외의 목적으로 사용하거나 제3자에게 제공하는 행위

③ 이용자가 제2항을 위반하여 회사 또는 기업회원에게 손해가 발생한 경우, 이용자는 그 손해를 배상할 책임을 부담합니다.

# 제4장 유료서비스·결제 및 청약철회
## 제13조(유료서비스, 가격 및 통화)
① 서비스의 일부는 유료로 제공됩니다. 가격은 미국 달러(USD)로 표시되며, 이용자가 한국 카드를 선택하는 경우 원화(KRW)로 전환되어 결제 전 정확한 원화 금액이 표시됩니다.

② 한국 카드는 원화로, 해외 카드 및 PayPal은 미국 달러로 결제됩니다. 결제는 회사의 결제대행사(Toss Payments, PayPal 등)를 통하여 처리되며, 회사는 카드번호 전체를 자체 서버에 저장하지 않습니다.

③ 미국 달러 결제의 경우 환율 변동 및 결제대행사 수수료로 인하여 실제 수령·환불 금액이 달라질 수 있으며, 회사는 이를 결제 전에 안내합니다.

## 제14조(청약철회 제한의 고지 및 동의)
① 이용자는 결제 전 해당 상품의 환불정책에 동의하여야 하며, 동의 없이는 결제가 진행되지 않습니다.

② 회사는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제6항에 따라, 비디오 코스·다운로드 자료·뷰온리 자료 등 디지털콘텐츠의 제공이 개시된 후에는 청약철회가 제한된다는 사실을 결제 화면 등 이용자가 쉽게 알 수 있는 곳에 명확히 표시하고, 이용자가 이를 확인하는 절차(체크박스 등)를 갖춥니다.

## 제15조(청약철회 및 환불)
① 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제1항에 따라 계약 내용에 관한 서면을 받은 날 또는 재화등의 공급이 시작된 날부터 7일 이내에 청약을 철회할 수 있습니다.

② 디지털콘텐츠의 제공이 개시된 경우에는 청약철회가 제한될 수 있습니다. 다만 가분적 디지털콘텐츠로 구성된 계약의 경우, 제공이 개시되지 아니한 부분(예: 미시청 강의)에 대하여는 청약철회가 가능합니다.

③ 중복 결제, 회사의 귀책, 기술적 오류 또는 법령에 따라 필요한 경우 회사는 환불 처리를 검토하며, 환불은 결제 통화(원화 또는 미국 달러)로 처리됩니다.

④ 상품 유형별 구체적인 환불 기준은 회사가 별도로 게시하는 환불정책에 따르며, 환불정책은 이 약관의 일부를 구성합니다.

## 제16조(워크숍·라이브 세션 참가 및 노쇼)
① 예약은 결제가 완료된 때에 확정되며, 좌석은 결제창(15분) 내 결제가 완료되지 않으면 반환됩니다. 매진 시 대기자 명단은 선착순으로 운영되고, 좌석 발생 시 알림은 제한된 시간(3시간) 동안만 유효합니다.

② 회사가 행사를 취소하는 경우 참가자 전원에게 전액 환불하며, 일정을 변경하는 경우 이용자는 변경된 일정을 수락하거나 전액 환불을 받을 수 있습니다.

③ 이용자가 사전 통지 없이 불참하는 경우(노쇼) 또는 행사 전에 취소하는 경우, 회사는 별도로 고지한 환불 규정에 따라 환불을 진행하며, 이 때 환불 규정은 본 약관상 환불 기준에 우선합니다. 별도로 고지한 환불 규정이 없을 경우 아래의 기준에 따라 환불을 진행합니다.
이용 일시로부터 48시간 전까지: 결제금액 100% 환불
이용 일시로부터 24시간 이상~48시간 미만 전: 결제금액 50% 환불
이용 일시로부터 24시간 미만 전: 환불 불가

# 제5장 개인정보 및 위치정보 보호
## 제17조(개인정보의 보호)
① 회사는 「개인정보 보호법」 등 관련 법령에 따라 이용자의 개인정보를 보호하며, 그 구체적인 사항은 개인정보처리방침에 따릅니다.

② 회사는 서비스 제공에 필수적인 항목과 선택적인 항목을 구분하여 동의를 받으며, 이용자는 선택적 동의를 거부할 수 있습니다.

## 제18조(위치정보의 처리)
① 회사는 Pathfinder 등 서비스 제공을 위하여 이용자가 직접 입력하는 거주 국가·도시 및 학교 소재지 정보를 수집할 수 있으며, 그 이용 목적은 비자 적격성 평가 및 한국 내 정착 경로 안내에 한정됩니다.

② 회사는 GPS, 기지국, Wi-Fi 등 전기통신설비를 이용한 자동 위치추적을 하지 아니하므로, 위 정보는 원칙적으로 「위치정보의 보호 및 이용 등에 관한 법률」상 개인위치정보에 해당하지 아니합니다.

③ 회사는 수집한 위치 관련 정보를 「개인정보 보호법」에 따라 보호하며, 수집 목적이 달성되면 지체 없이 파기합니다.

## 제18조의2(체류자격 정보의 제공 및 이용자의 책임)
① 이용자는 체류자격, 비자 종류, 발급일, 체류 만료일 등 체류자격 관련 정보를 서비스에 등록할 수 있으며, 등록한 정보를 정확하게 유지하고 변경 사항이 있는 경우 지체 없이 수정하여야 합니다.

② 이용자는 체류자격 관련 정보를 제공할 정당한 권한을 보유하고 있음을 보증하며, 허위의 정보를 등록하여서는 안 됩니다.

③ 이용자는 「출입국관리법」에 따라 취업활동이 가능한 체류자격을 스스로 갖추어야 하며, 회사는 이용자의 체류자격 적격 여부를 보증하지 아니합니다.

④ 이용자가 허위 또는 부정확한 체류자격 정보를 제공하거나 취업활동이 허용되지 않는 체류자격으로 서비스를 이용하여 회사 또는 제3자에게 손해가 발생한 경우, 이용자는 그 손해를 배상할 책임을 부담합니다.

# 제6장 서비스 변경·중단 및 책임
## 제19조(서비스의 변경 및 중단)
① 회사는 서비스의 전부 또는 일부를 변경·일시중단 또는 종료할 수 있으며, 중요한 변경 사항은 사전에 안내합니다. 유료 상품이 영향을 받는 경우 환불정책에 따라 환불합니다.

② 정기·긴급 점검, 네트워크·전원 장애, 천재지변 등 불가항력의 경우 서비스가 일시 제한될 수 있으며, 회사는 가능한 범위에서 이를 사전 또는 사후에 공지합니다.

## 제20조(면책)
① 회사는 관련 법령이 허용하는 범위에서 서비스를 '있는 그대로' 제공하며, 취업·비자 발급·시험 점수 등 특정 결과를 보장하지 않고, 서비스가 항상 중단 없이 제공됨을 보장하지 않습니다.

② 회사는 고의 또는 중대한 과실이 없는 이상, 이용자가 다른 학습자·크리에이터·임직원의 서비스나 콘텐츠를 이용하는 과정에서 입은 손해에 대해 책임지지 않습니다.

## 제21조(책임의 제한)
① 회사가 이용자에게 부담하는 손해배상 책임은 통상의 직접 손해에 한정하며, 그 상한은 해당 손해와 관련하여 이용자가 회사에 직접 지급한 서비스 요금으로 합니다.

② 제1항은 회사의 고의 또는 중대한 과실이 객관적으로 인정되며, 그 인과관계가 입증된 손해에는 적용하지 않습니다.

## 제22조(이용 제한 및 계약 해지)
① 회사는 이용자가 이 약관을 위반하거나 서비스 운영을 방해하는 경우 이용을 제한하거나 계약을 해지할 수 있습니다.

② 회사는 이용 제한·해지 시 원칙적으로 사전에 그 사유와 이의신청 방법을 통지합니다. 다만 긴급하거나 중대한 위반의 경우에는 사후에 통지할 수 있습니다.

③ 이용 제한·해지로 인하여 이용자가 이미 결제한 유료 상품을 이용하지 못하게 되는 경우, 회사는 환불정책 및 관련 법령에 따라 환불을 처리합니다.

④ 이용자는 언제든지 서비스 이용을 중단하고 계정 삭제(회원 탈퇴)를 요청할 수 있습니다.

# 제7장 국제 서비스, 준거법 및 분쟁 해결
## 제23조(국제 서비스)
서비스는 대한민국 외 지역의 이용자에게도 제공될 수 있으며, 해당 국가의 강행법규가 적용될 수 있습니다. 이 경우 회사는 해당 국가 대상 서비스에 적용되는 사항을 별도로 안내할 수 있습니다.

## 제24조(준거법 및 분쟁 해결)
① 이 약관은 대한민국 법령에 따라 해석·적용됩니다.

② 서비스 이용과 관련하여 분쟁이 발생한 경우 당사자는 성실히 협의하여 해결하도록 노력합니다.

③ 이용자는 소비자분쟁조정위원회, 콘텐츠분쟁조정위원회, 개인정보분쟁조정위원회(1833-6972) 등 관련 기관의 조정·상담을 이용할 수 있습니다.

# 부칙
① 이 약관은 2026년 08월 28일부터 시행합니다.

② 이 약관 시행 전의 기존 이용약관은 이 약관으로 대체됩니다.

코레디 (Koready) | contact@ko-ready.com | 사업자등록번호 179-45-01005`;

/** 정책 문서 한 버전(국문). 노션 Policy Hub 「Koready 이용약관 (개인회원)」 원문. */
export default {
  lang: 'ko',
  title: '이용약관',
  lastUpdated: '2026년 8월 28일',
  lastUpdatedLabel: '시행일',
  effectiveDate: '2026-08-28',
  sections: parsePolicyText(TEXT),
};
